import PropTypes from 'prop-types';
import React from 'react';

import WildlifeSummaryRow from './WildlifeSummaryRow';

const WildlifeSummary = ({wildlifeInfo}) => {
  return (
    <div className="WildlifeSummary">
      <WildlifeSummaryRow
        animalClass="Reptiles"
        speciesCount={wildlifeInfo.countReptiles}
      />

      <div className="WildlifeSummary__divider"/>

      <WildlifeSummaryRow
        animalClass="Amphibians"
        speciesCount={wildlifeInfo.countAmphibians}
      />

      <div className="WildlifeSummary__divider"/>

      <WildlifeSummaryRow
        animalClass="Mammals"
        speciesCount={wildlifeInfo.countMammals}
      />
    </div>
  );
};

WildlifeSummary.propTypes = {
  "wildlifeInfo": PropTypes.object.isRequired,
};

export default WildlifeSummary;



// WEBPACK FOOTER //
// ./src/components/WildlifeSummary.js